import { render, staticRenderFns } from "./app_fields.vue?vue&type=template&id=22c14717&"
import script from "./app_fields.vue?vue&type=script&lang=js&"
export * from "./app_fields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports